import React from "react";

//#region Types
import { AnnualReportAuditorTimelineProps } from "models/propTypes/annualAccountPropTypes";
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
//#endregion
//#region Components
import SimpleTimeline from "components/common/charts/timeline/simpleTimeline";
import { useResponsibleText } from "./hooks/useResponsibleText";
import { useTimelineStepState } from "./hooks/useTimelineStepState";
//#endregion
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";

const AnnualReportAuditorTimeline: React.FC<AnnualReportAuditorTimelineProps> = ({
  annualReportState,
  auditorState,
}) => {
  const getResponsibleText = useResponsibleText();
  const getStepState = useTimelineStepState();

  const timelineSteps = [
    {
      key: TranslationKeys.AnnualAccount.AnnualReportTimeLineStep1,
      responsible: WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson.Customer,
    },
    {
      key: TranslationKeys.AnnualAccount.AnnualReportTimeLineStep1,
      responsible: WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson.Revisor,
    },
    {
      key: TranslationKeys.AnnualAccount.AnnualReportAuditorReportStep,
      responsible: WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson.Revisor,
    },
    {
      key: TranslationKeys.AnnualAccount.AnnualReportTimeLineStep2,
      responsible: WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson.Customer,
    },
    {
      key: TranslationKeys.AnnualAccount.AnnualReportTimeLineStep3,
      responsible: WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson.Customer,
    },
  ];

  const stepState = getStepState(annualReportState, auditorState, timelineSteps.length);

  const timelineItems = timelineSteps.map((step, index) => ({
    text: LocalizationHelperInstance.getFormattedMessage(step.key),
    subText: [getResponsibleText(step.responsible)],
    type: stepState[index],
  }));

  return <SimpleTimeline items={timelineItems} />;
};

export default AnnualReportAuditorTimeline;
